/**
 * Notification TanStack Query hooks.
 */

import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { notificationKeys } from "@/queries/keys";
import {
  notificationApi,
  type NotificationParams,
  type NotificationListResponse,
} from "./api";

export type { NotificationItem, NotificationListResponse } from "./api";

export type NotificationFilters = Partial<NotificationParams>;

/** Fetch paginated notification list with optional filters. */
export function useNotifications(filters: NotificationFilters = {}) {
  const {
    page = 0,
    pageSize = 25,
    sortBy = "createdAt",
    sortDir = "desc",
    ...rest
  } = filters;

  const params: NotificationParams = {
    page,
    pageSize,
    sortBy,
    sortDir,
    ...rest,
  };

  return useQuery({
    queryKey: notificationKeys.list(params as unknown as Record<string, unknown>),
    queryFn: async () => {
      const res = await notificationApi.getNotifications(params);
      if (!res.success) throw new Error(res.error ?? "Failed to fetch notifications");
      return res.data as NotificationListResponse;
    },
    placeholderData: keepPreviousData,
  });
}
